import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { phoneNumberFormatter } from '@dreryk/react-common';

type PhoneNumberCellProps = {
   readonly phoneNumber: PhoneNumber | undefined;
};

export const PhoneNumberCell = (props: PhoneNumberCellProps): JSX.Element => {
   const phoneNumber = phoneNumberFormatter(props.phoneNumber);

   return <>{phoneNumber}</>;
};
